import React from "react";
import { useSelector } from "react-redux";
import { InputLabel, MenuItem, Select, FormControl } from "@mui/material/";
import { strings } from "../i18n";

type Props = {
    defaultValue: any,
    multiple: boolean,
    onChangeVal: Function
};

/**
 * Branch Select Component
 */
export default ({ defaultValue, multiple = false, onChangeVal }: Props) => {
    const { branches } = useSelector((state) => state);
    const [value, setValue] = React.useState("");

    React.useEffect(() => {
        defaultValue && setValue(defaultValue);
    }, [defaultValue]);

    const onValueChange = (event: Event) => {
        setValue(event.target.value);
        onChangeVal && onChangeVal(event.target.value);
    };

    return branches.data.length ? (
        <FormControl variant="standard">
            <InputLabel>{strings(multiple ? "branches" : "branch")}</InputLabel>
            <Select
                multiple={multiple}
                onChange={onValueChange}
                value={multiple && !value ? [] : value}
            >
                {branches.data.map(({ id, name }) => (
                    <MenuItem key={id} value={id}>
                        {name}
                    </MenuItem>
                ))}
            </Select>
        </FormControl>
    ) : null;
};
